import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { Text } from '@wix/wix-ui-tpa/cssVars';

import { classes } from './SectionTitle.st.css';

type SectionTitleProps = {
  id?: string;
  htmlTag?: string;
};

export const SectionTitle: FC<PropsWithChildren<SectionTitleProps>> = ({
  id,
  children,
  htmlTag = 'h3',
}) => {
  return (
    <Text id={id} className={classes.root} tagName={htmlTag}>
      {children}
    </Text>
  );
};
